<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="my-page">
      <div class="title_area">
        <img src="/img/mypage_icon/10.png" alt="">
        <Title jpn="My page" class="_title"/>
      </div>
      <div class="base_area">
        <div class="col">
          <div class="member_area">
            <h4>member number</h4>
            <span>{{ currentUserDetail.id }}</span>
          </div>
          <GrayBack class="gray_area name_back">
            <div class="name_area">
              <span>{{ lastName }} {{ firstName }}</span>
            </div>
          </GrayBack>
          <!-- <h4>Your gems</h4>
          <h5>{{ point | comma }}Gem</h5>
          <div class="button_area">
            <SquareButton
              class="square-button"
              text="Buy gems"
              @handleSquareBtnClick="goToPointBuy"
            />
          </div> -->

          <!-- <BarGraph
            :maxValue="rankNextPrice"
            :currentValue="rankCurrentPrice"
            :rankName="rankName"
            barColor="#20366F"
          />
          <div v-if="isRankMaintained" class="button_area">
            <BlackGradationButton
              class="square-button"
              text="Maintains rank next month"
              @handleSquareBtnClick="clickMaintainRank"
            />
          </div> -->
        </div>
        <div class="col">
          <div class="rank_area">
            <div class="rank_area_title">Your Monthly Rank</div>
            <BarGraph
              :maxValue="rankNextPrice"
              :currentValue="rankCurrentPrice"
              :rankName="rankName"
              :remainingPoint="currentUserDetail.remaining_point"
              barColor="#20366F"
            />
            <div v-if="isRankMaintained" class="button_area">
              <BlackGradationButton
                class="square-button"
                text="Maintains rank next month"
                @handleSquareBtnClick="clickMaintainRank"
              />
            </div>
          </div>
        </div>
        <!-- <div class="col">
          <div class="link_area">
            <GrayBack class="gray_area">
              <div class="link" @click="goToPointHistory">Your gems history</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goToBuyProductHistory">Buying history</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goToUserGuide">User guide</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goContactUs">Contact us</div>
            </GrayBack>
            <GrayBack class="gray_area">
              <div class="link" @click="goToUserMenu">Setting registration information</div>
            </GrayBack>
          </div>
          <div class="button_area button_logout">
            <BlackGradationButton
              class="square-button"
              text="Logout"
              img="/img/logout_icon.png"
              @handleSquareBtnClick="logout"
            />
          </div>
        </div> -->
      </div>
      <div class="icon_area">
        <div class="box" @click="handoleClickSmsCheck()">
          <img src="/img/mypage_icon/11.png" alt="">
          <div>SMS authentication</div>
        </div>
        <div class="box" @click="goToPointHistory">
          <img src="/img/mypage_icon/12.png" alt="">
          <div>Your gems history</div>
        </div>
        <div class="box" @click="goToBuyProductHistory">
          <img src="/img/mypage_icon/13.png" alt="">
          <div>Buying history</div>
        </div>
        <div class="box" @click="goToUserGuide">
          <img src="/img/mypage_icon/14.png" alt="">
          <div>User guide</div>
        </div>
        <div class="box" @click="goContactUs">
          <img src="/img/mypage_icon/15.png" alt="">
          <div>Contact us</div>
        </div>
        <div class="box" @click="goToUserMenu">
          <img src="/img/mypage_icon/16.png" alt="">
          <div>Setting</div>
        </div>
      </div>
      <div class="description" id="referral">
        <div class="description_title_area">
          <div class="description_title">Refer Friend Program</div>
          <div class="description_sub_title sp">Referrals and fulfillment of conditions<br class="sp"> will both receive 1,000 Gems!!</div>
          <div  v-if="currentUserDetail.end_sms == '1'" class="sms_code_area">
            <div class="sms_code_title">Referral Code</div>
            <div class="sms_code">{{ currentUserDetail.referral_code }}</div>
            <button @click="copyReferralCode(currentUserDetail.referral_code)">Copy</button>
          </div>
        </div>
        <div class="description_step">
          <div class="left">
            <div class="description_sub_title pc">Referrals and fulfillment of conditions<br class="sp"> will both receive 1,000 Gems!!</div>
            <div class="steps-container pc">
              <div class="steps">
                  <div>STEP<br>
                    <span>01</span>
                  </div>
                  <p>Get a referral code<br>with sms verification.</p>
              </div>
              <div class="steps">
                  <div>STEP<br>
                    <span>02</span>
                  </div>
                  <p>Have your friends enter<br>your referral codeafter<br>they sign up.</p>
              </div>
              <div class="steps">
                  <div>STEP<br>
                    <span>03</span>
                  </div>
                  <p>Your friend has to complete<br>SMS verification and purchase<br>at least 1,000 gems.</p>
              </div>
            </div>
            <div class="steps-container-sp sp">
              <div class="steps-container-sp_box">
                <span>Get a referral code with<br>sms verification.</span>
                <div class="steps-container-sp_mark">
                    <div>
                      <div>STEP</div>
                      <div class="num">01</div>
                    </div>
                </div>
              </div>
              <div class="steps-container-sp_box">
                <span>Have your friends enter your<br>referral codeafter they sign up.</span>
                <div class="steps-container-sp_mark">
                    <div>
                      <div>STEP</div>
                      <div class="num">02</div>
                    </div>
                </div>
              </div>
              <div class="steps-container-sp_box">
                <span>Your friend has to complete<br>SMS verification and purchase<br>at least 1,000 gems.</span>
                <div class="steps-container-sp_mark">
                    <div>
                      <div>STEP</div>
                      <div class="num">03</div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="step_jem">
              <div class="step_jem_top">
                <div class="step_title">1,000 Gems<br> acquired!</div>
                <img src="/img/mypage_icon/9.png" alt="">
              </div>
              <div class="step_sub_title">Unlimited number of referrals</div>
            </div>
          </div>
        </div>
        <!-- <div v-if="currentUserDetail.end_sms == '0'" class="sms_btn_area">
          <RoundButton
            class="square-button square-button__sms"
            @handleRoundBtnClick="handoleClickSmsCheck()"
          >
            sms authentication<br class="sp"> to get a Referral Code▶︎
          </RoundButton>
        </div> -->
        <!-- <div class="step_area">
          <div class="step">
            <div class="step_title">Step1</div>
            <div>Get a referral code with<br class="pc"> sms verification.</div>
          </div>
          <div class="step">
            <div class="step_title">Step2</div>
            <div>Have your friends enter your<br class="pc"> referral code<br class="sp"> after they sign<br class="pc">up for.</div>
          </div>
          <div class="step">
            <div class="step_title">Step3</div>
            <div>Your friend has to complete<br class="pc">SMS verification<br class="sp"> and purchase<br class="pc">at least 1,000 gems.</div>
          </div>
          <div class="step step_jem pc">
            <div class="step_title">1,000 Gems acquired!</div>
            <div>Unlimited number of referrals!</div>
            <img src="/img/mypage_icon/9.png" alt="">
          </div>
          <div class="step step_jem sp">
            <div class="step_jem_top">
              <div class="step_title">1,000 Gems<br> acquired!</div>
              <img src="/img/mypage_icon/9.png" alt="">
            </div>
            <div >Unlimited number of referrals!</div>
          </div>
          <div class="step_img_sp sp">
            <img src="/img/mypage_icon/8.png" alt="">
          </div>
        </div> -->
        <!-- <div class="step_img_pc pc">
          <img src="/img/mypage_icon/7.png" alt="">
        </div> -->
      </div>
      <InputCouponCode></InputCouponCode>
      <div class="button_area button_logout pc">
        <BlackGradationButton
          class="square-button"
          text="Logout"
          img="/img/logout_icon.png"
          @handleSquareBtnClick="logout"
        />
      </div>
    </div>
    <div class="button_area button_logout sp">
      <BlackGradationButton
        class="square-button"
        text="Logout"
        img="/img/logout_icon.png"
        @handleSquareBtnClick="logout"
      />
    </div>
    <CommonOverlay class="overlay" v-show="isOpenConfirm && isRankMaintained">
      <CommonModal class="modal pack-confirm">
        <span class="close" @click="isOpenConfirm = false">&times;</span>
        <div class="modal-title">
          <span>Maintain rank next month</span>
        </div>
        <div class="bay_area">
          <div class="modal-subtitle">
            <span>Next month's start rank</span>
          </div>
          <div class="use_num">
            <span>{{ rankNextMonthName }}</span>
          </div>
        </div>
        <div class="bay_area">
          <div class="modal-subtitle">
            <span>Use coin</span>
          </div>
          <div class="use_num">
            <span>{{ rankCoin | comma }}C</span>
          </div>
          <div class="modal-subtitle">
            <span>Coins held</span>
          </div>
          <div class="use-point">
            <div class="point-area">{{ currentUser.coin | commaFloat }}C</div>
            <div>→</div>
            <div class="point-area">{{ currentUser.coin - rankCoin | commaFloat }}C</div>
          </div>
        </div>
        <div class="modal-button-area">
          <BlackGradationButton class="bay-button" text="Maintain rank next month" @handleSquareBtnClick="buyRank" />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay" v-show="isOpenConp">
      <CommonModal class="modal pack-confirm">
        <span class="close" @click="isOpenConp = false">&times;</span>
        <div class="modal-title">
          <span>Maintain rank next month</span>
        </div>
        <div class="modal-title">
          <span>Maintained the starting rank for next month to {{ rankNextMonthName }}.</span>
        </div>
        <div class="modal-button-area">
          <BlackGradationButton class="bay-button" text="閉じる" @handleSquareBtnClick="isOpenConp = false" />
        </div>
      </CommonModal>
    </CommonOverlay>

    <CommonOverlay class="overlay" v-show="isSmsShow">
      <CommonModal class="modal pack-confirm">
        <span class="close" @click="isSmsShow = false">&times;</span>
        <div class="sms_pop_title">
          <span>Tel</span>
          <TextBox
            class="text-box"
            inputType="text"
            :value="tel"
            placeholder="Tel"
            @handleTextInput="inputTel"
          />
          <ErrorMessage
            v-if="telErrorMessage"
            class="error-message"
            :message="telErrorMessage"
          />
          <BlackGradationButton class="bay-button sendcode-btn" text="Send Code" @handleSquareBtnClick="goToSendSms" />
        </div>
        <div class="sms_pop_title">
          <span>Code</span>
          <TextBox
            class="text-box"
            inputType="text"
            :value="code"
            placeholder="Code"
            @handleTextInput="inputCode"
          />
          <ErrorMessage
            v-if="codeErrorMessage"
            class="error-message"
            :message="codeErrorMessage"
          />
          <BlackGradationButton class="bay-button confirm-btn" text="verify" @handleSquareBtnClick="goToSendCode" />
        </div>
      </CommonModal>
    </CommonOverlay>

    <CommonOverlay class="overlay" v-show="isComplete">
      <CommonModal class="modal pack-confirm">
        <span class="close" @click="isComplete = false">&times;</span>
        <div class="completed-txt">sms authentication completed</div>
        <div>
          <img src="/img/check.png" alt="">
        </div>
        <BlackGradationButton class="bay-button confirm-btn" text="Confirm" @handleSquareBtnClick="isComplete = false" />
      </CommonModal>
    </CommonOverlay>

    <CommonOverlay class="overlay" v-show="isAlreadyDone">
      <CommonModal class="modal pack-confirm">
        <span class="close" @click="isAlreadyDone = false">&times;</span>
        <div>It’s already done.</div>
        <BlackGradationButton class="bay-button confirm-btn" text="Confirm" @handleSquareBtnClick="isAlreadyDone = false" />
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import InputCouponCode from '@/components/pages/MyPage/InputCouponCode.vue';
// import SquareButton from '@/components/atoms/SquareButton.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';
import BarGraph from '@/components/atoms/BarGraph.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
// import RoundButton from '@/components/atoms/RoundButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';

export default {
  name: 'MyPage',
  mixins: [t],

  components: {
    BaseTemplate,
    GrayBack,
    BlackGradationButton,
    // SquareButton,
    Title,
    BarGraph,
    CommonOverlay,
    CommonModal,
    // RoundButton,
    TextBox,
    ErrorMessage,
    InputCouponCode,
  },

  directives: {
    ClickOutside,
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
    commaFloat(value) {
      return separateDecimalNumber(value, true);
    },
  },

  data: () => ({
    lastName: null,
    firstName: null,
    point: null,
    rankName: null,
    rankNextPrice: 0,
    rankCurrentPrice: 0,
    rankCoin: 0,
    rankNextMonthName: '',
    rankNextMonth: 1,
    isRankMaintained: false,
    isOpenConfirm: false,
    isOpenConp: false,
    isSmsShow: false,
    isComplete: false,
    telErrorMessage: null,
    codeErrorMessage: null,
    tel: null,
    code: null,
    isAlreadyDone: false,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentUserDetail: 'user/currentUserDetail',
      currentAddress: 'zipCode/currentAddress',
      changeUserInformationResult: 'user/changeUserInformationResult',
      logOutUserResult: 'user/logOutUserResult',
      buyRankResult: 'user/buyRankResult',
      sendSMS: 'sms/sendSMS',
      checkSMS: 'sms/checkSMS',
    }),
  },

  watch: {
    currentUserDetail(newResult) {
      this.$nextTick(() => {
        this.lastName = newResult.lastName;
        this.firstName = newResult.firstName;
        this.point = newResult.availablePoint;
        this.rankName = newResult.rank_name;
        this.rankCoin = newResult.rank_coin;
        this.rankNextPrice = newResult.rank_max_price;
        this.rankCurrentPrice = newResult.rank_current_price;
        this.isRankMaintained = newResult.is_rank_maintained;
        this.rankNextMonthName = newResult.next_month_name;
        this.rankNextMonth = newResult.next_month;
        this.tel = newResult.tel;
      });
      this.$store.dispatch('user/setPointEndResult');
    },
    logOutUserResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearLogOutUserResult');
          this.$router.push('/login');
        }
      }
    },
    sendSMS(newVal) {
      if (newVal.state === 200) {
        alert('Please enter the code sent by SMS');
        return;
      }
      if (newVal.errors.user_id) {
        this.telErrorMessage = newVal.errors.user_id ? newVal.errors.user_id[0] : '';
      }
    },
    checkSMS(newVal) {
      if (newVal.state === 200) {
        this.isSmsShow = false;
        this.$store.dispatch('user/setCurrentUserDetail');
        this.isComplete = true;
        return;
      }
      if (newVal.errors.sms_code) {
        this.codeErrorMessage = newVal.errors.sms_code ? newVal.errors.sms_code[0] : '';
      }
    },
  },

  created() {
    this.$store.dispatch('user/setCurrentUserDetail');
  },

  mounted() {
    if (window.location.href.includes('#referral')) {
      const scrollElement = () => {
        const targetElement = document.querySelector('#referral');
        if (targetElement) {
          const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: offsetTop - 100,
          });
        } else {
          setTimeout(scrollElement, 100);
        }
      };
      scrollElement();
    }
  },

  methods: {
    logout() {
      this.$store.dispatch('user/logOutUser');
    },
    goToUserMenu() {
      this.$router.push('./user-menu');
    },
    goToPointBuy() {
      this.$router.push('./buy-point');
    },
    goToBuyProductHistory() {
      this.$router.push('/buy-product-history');
    },
    goToPointHistory() {
      this.$router.push('./buy-point-history');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    goContactUs() {
      if (process.env.VUE_APP_LANG_MODE === 'jp') {
        window.open('https://minny-online-store.iranoan.com/contacts?service=1', '_blank');
      } else {
        window.open('https://minny-online-store.iranoan.com/contacts?service=1', '_blank');
      }
    },
    clickMaintainRank() {
      this.$store.dispatch('user/setCurrentUserDetail');
      if (this.currentUser.coin < this.rankCoin) {
        window.alert('コインが不足しています');
        return;
      }
      this.isOpenConfirm = true;
    },
    buyRank() {
      (async () => {
        this.isOpenConfirm = false;
        const postParams = {
          coin: this.rankCoin,
          next_month_rank: this.rankNextMonth,
        };
        await this.$store.dispatch('user/buyRank', { postParams });
        const { buyRankResult } = this;
        const isSuceess = buyRankResult.state === 200 && buyRankResult.result === '1';
        if (isSuceess) {
          this.isOpenConp = true;
          this.$store.dispatch('user/setCurrentUser');
          this.$store.dispatch('user/setCurrentUserDetail');
        } else {
          const { count } = buyRankResult.errors;
          window.alert(count);
        }
      })();
    },
    inputTel(value) {
      this.tel = value;
    },
    inputCode(value) {
      this.code = value;
    },
    goToSendSms() {
      const postParams = { tel: this.tel };
      this.$store.dispatch('sms/sendSMS', { postParams });
    },
    goToSendCode() {
      const postParams = { sms_code: this.code };
      this.$store.dispatch('sms/checkSMS', { postParams });
    },
    handoleClickSmsCheck() {
      if (this.currentUserDetail.end_sms === '0') {
        this.isSmsShow = true;
      } else {
        this.isAlreadyDone = true;
      }
    },
    copyReferralCode(referralCode) {
      window.navigator.clipboard.writeText(referralCode)
        .then(() => {
          alert('Referral Code copied');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-page{
  width: 100%;
  max-width: 800px;
  // padding-top: 30px;
  // padding-bottom: 50px;
  padding: 30px 30px 50px 30px;
  margin: 0px auto;
  // @include appendMap($backgroundStyleMap);
  background-color: #0693ee;
  .title_area {
    display: flex;
    align-items: center;
    img {
      width: 50px;
      margin-right: 10px;
    }
  }
  ._title {
    text-align: left;
  }
  .address_change {
    margin-top: 5px;
  }
  .col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    width: 100%;
    padding: 12px;
  }
  .base_area {
    display: flex;
    .gray_area {
      width: 100%;
      background-color: $lightColor;
    }
    .gray_area.name_back {
      // background-color: #384864;
      background-color: initial;
      padding-bottom: 0;
    }
    .member_area {
      display: flex;
      align-items: center;
      // justify-content: center;
      // margin-top: 10px;
      h4 {
        padding: 0px 10px 0 0;
        margin: 0px 20px 0px 0px;
        background-color: initial;
        color: $white;
      }
      span {
        // color: $white;
        font-size: 20px;
        background-color: $white;
        width: 50%;
        text-align: center;
        border-radius: 20px;
      }
    }
    .name_area {
      color: $white;
      width: 100%;
      text-align: center;
      font-size: 24px;
    }
    h4 {
      margin: 40px 40px 10px 40px;
      background-color: $white;
      color: $deepColor;
      text-align: center;
      font-weight: normal;
    }
    h5 {
      text-align: center;
      color: $white;
      font-size: 36px;
    }
    .button_area {
      margin-top: 20px;
      .square-button {
        max-width: 300px;
        margin: auto;
      }
    }
    .link_area {
      .gray_area {
        padding: 10px 0;
        text-align: center;
        color: $white;
        margin: 5px 0;
        cursor: pointer;
        transition: .4s;
        &:nth-child(1) {
          margin-top: 0;
        }
        &:hover {
          background-color: $mainColor;
        }
      }
    }
  }
}
.button_logout {
  margin-top: 20px;
  .square-button {
    background-color: initial;
    max-width: 200px;
    margin: auto;
  }
}
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30px;

  .modal {
    padding: 40px 28px;
    font-family: $notoSans;
    color: #000;
    text-align: center;
    width: 586px;

    .modal-title {
      font-size: 24px;
      font-weight: bold;
    }

    .text {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
    }

    .modal-button-area {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 30px;

      .square-button {
        width: 120px;
        height: 50px;

        &+.square-button {
          margin-left: 20px;
        }
      }
    }
  }
}
.pack-confirm {
  background-color: #fff;
  color: #000;
  position: absolute;
  height: auto;

  .close {
    /* 閉じるボタンを右上に表示 */
    position: absolute;
    top: -30px;
    right: 10px;
    /* 閉じるボタンの大きさ */
    font-size: 64px;
    /* 閉じるボタンのカーソル */
    cursor: pointer;
  }

  .bay_area {
    background-color: $lightGray;
    padding: 20px 0;
    border-radius: 9px;
    & + .bay_area {
      margin-top: 10px;
    }
  }

  .modal-subtitle {
    width: 50%;
    margin: auto;
    background-color: $mainColor;
    color: #fff;
  }

  .use_num {
    font-size: 40px;
    font-weight: bold;
    color: #000;
  }

  .use-point {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
    width: 50%;
    margin: auto;
  }

  .bay-button {
    width: 100%;
    height: 52px;
  }
  .completed-txt {
    margin-bottom: 20px;
  }
  .sendcode-btn {
    background-color: #fff;
    color: #081b40;
    border-color: #081b40;
    margin-top: 20px;
  }
  .confirm-btn {
    width: 50%;
    margin: 20px auto 0;
    background-color: #081b40;
  }
}
.rank_area {
  background-color: #85dbff;
  padding: 5px;
  border-radius: 20px;
  .rank_area_title {
    // color: $white;
    color: #0020aa;
    font-size: 16px;
    // background-color: #384864;
    padding: 10px 0px;
    text-align: center;
    // width: 200px;
    margin: auto;
    font-weight: bold;
  }
  .square-button {
    background-color: initial;
  }
}
.icon_area {
  display: flex;
  justify-content: space-around;
  text-align: center;
  .box {
    width: calc(100% / 6.2);
    max-width: 180px;
    // background-color: $white;
    font-size: 12px;
    padding: 15px 0 15px 0;
    color: $white;
    border: 1px solid $white;
    font-weight: bold;
    cursor: pointer;
    img {
      height: 24px;
      margin-bottom: 5px;
    }
    div {
      font-size: 12px;
      line-height: 10px;
    }
    @media screen and (max-width: $tabletWidth) {
      div {
        font-size: 10px;
        line-height: 10px;
      }
    }
  }
}
.description {
  background-color: $white;
  // color: #20366F;
  color: #0020aa;
  border-radius: 10px;
  margin-top: 40px;
  padding: 10px 15px;
  font-weight: bold;
  .description_title_area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      background-color: #0693ee;
      color: $white;
      padding: 5px 10px;
      border-radius: 10px;
      margin-left: 10px;
    }
  }
  .description_title {
    font-size: 28px;
    text-align: center;
  }
  .description_sub_title {
    text-align: center;
  }
  .sms_btn_area {
    text-align: center;
  }
  .square-button__sms {
    max-width: 370px;
    background-color: #709DF2;
    margin: auto;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
    border-radius: 100px;
  }
  .sms_code_area {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .sms_code {
      padding: 10px;
      background-color: #d2d6e2;
      border-radius: 4px;
      width: 180px;
      margin-left: 10px;
      text-align: center;
      @media screen and (max-width: $tabletWidth) {
        width: 130px;
      }
    }
  }
  .description_step {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .left {
      .description_sub_title {
        font-size: 18px;
      }
      .steps-container {
        display: flex;
        align-items: center;
        height: 80%;
      }
      .steps {
        position: relative;
        padding: 5px;
        text-align: center;
        color: white;
        clip-path: polygon(0 0, calc(100% - 40px) 0, 100% 50%, calc(100% - 40px) 100%, 0 100%, 40px 50%);
        margin-right: -30px;
        z-index: 1;
        height: 80%;
        width: 200px;
        background: linear-gradient(90deg, #2b86f7, #1aa9eb);
      }
      .steps:last-child {
        margin-right: 0;
      }
      .steps div {
        margin: 0;
        font-weight: bold;
        span {
          font-size: 24px;
        }
      }
      .steps p {
        margin: 10px 0 0;
        font-size: 10px;
      }
    }
    .right {
      .step_jem {
        .step_jem_top {
          text-align: center;
          .step_title {
            font-size: 24px;
            color: red;
            font-weight: bold;
            text-shadow: 0 0 1px red;
          }
        }
        .step_sub_title {
          font-size: 12px;
          text-align: center;
        }
      }
    }
  }
}
.step_area {
  display: flex;
  font-weight: bold;
  margin-top: 15px;
  position: relative;
  @media screen and (max-width: $tabletWidth) {
    padding-right: 20px;
  }
  .step {
    margin-right: 20px;
    font-size: 14px;
  }
  .step_jem {
    position: absolute;
    right: -40px;
    top: -40px;
    font-size: 12px;
    text-align: center;
    .step_title {
      font-size: 14px;
    }
    img {
      width: 70%;
      margin-top: 5px;
    }
  }
  .step_jem {
    margin-top: 0;
    margin-right: 20px;
    @media screen and (max-width: $tabletWidth) {
      margin-top: 30px;
      margin-right: 0;
    }
  }
}
.step_img_pc {
  text-align: center;
  margin-top: 10px;
  img {
    width: 95%;
  }
}
.sp {
  display: none;
}
.pc {
  display: block;
}
.sms_pop_title {
  text-align: left;
}
.steps-container-sp {
  .steps-container-sp_box {
    background-color: #85dbff;
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-top: 30px;
    height: 80px;
    position: relative;
    padding-left: 120px;
    font-size: 14px;
    .steps-container-sp_mark {
      top: -5px;
      left: 10px;
      position: absolute;
      padding: 5px;
      text-align: center;
      color: white;
      clip-path: polygon(0 0, 100% 0, 100% 80%, 50% 100%, 0 80%);
      margin-right: -30px;
      z-index: 1;
      height: 100px;
      width: 100px;
      background: linear-gradient(90deg, #2b86f7, #1aa9eb);
      div {
        font-size: 20px;
      }
      .num {
        font-size: 40px;
        margin-top: -15px;
      }
    }
  }
  :nth-child(1) {
    margin-top: 5px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .my-page{
    padding: 30px 10px 15px 10px;
    margin: 0px 10px;
    width: initial;
    .title_area {
      justify-content: center;
    }
    ._title {
      margin-bottom: 0;
    }
    .base_area {
      display: flex;
      flex-direction: column;
      .gray_area.name_back {
        padding-top: 20px;
      }
      .member_area {
        justify-content: center;
        h4 {
          margin: 0;
        }
      }
    }
  }
  .overlay {
    .modal {
      width: 80%;
    }
  }
  .pack-confirm {
    .modal-subtitle {
      font-size: 12px;
    }

    .use_num {
      font-size: 20px;
    }

    .bay-button {
      height: 45px;
    }
  }
  .icon_area {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .box {
      // width: calc(100% / 3.1);
      width: calc(100% / 2.1);
    }
    .box:nth-child(2),
    .box:nth-child(4),
    .box:nth-child(6) {
      margin-left: 10px;
    }
    .box:nth-child(3),
    .box:nth-child(4),
    .box:nth-child(5),
    .box:nth-child(6) {
      margin-top: 10px;
    }
  }
  .description {
    margin-top: 15px;
    .description_title_area {
      flex-direction: column;
    }
    .description_title {
      font-size: 28px;
    }
    .square-button__sms {
      margin-top: 10px;
      width: 85%;
      font-size: 12px;
    }
    .description_step {
      flex-direction: column;
      .right {
        .step_jem {
          .step_jem_top {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
          }
          .step_sub_title {
            font-size: 20px;
          }
        }
      }
    }
  }
  .step_area {
    flex-direction: column;
    .step {
      margin-right: 0;
      margin-bottom: 10px;
    }
    .step_jem {
      position: initial;
      text-align: center;
      .step_jem_top {
        display: flex;
        align-items: center;
        font-size: 16px;
        .step_title {
          font-size: 24px;
        }
        img {
          width: initial;
        }
      }
    }
  }
  .step_img_sp {
    position: absolute;
    right: 0;
    top: 0;
  }

  .sp {
    display: block;
  }
  .pc {
    display: none !important;
  }
}
</style>
